import React, { useState } from "react";
import axios from "axios";
import Header from "../components/Header";
import "../css/ContactUs.css";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    companyName: "",
    country: "+91",
    phone: "",
    subject: "",
    message: "",
    checkbox: false,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const validateForm = () => {
    let formErrors = {};
    const letters = /^[a-zA-Z\s]*$/;

    // Name validation
    if (!formData.name) {
      formErrors.name = "Please fill out this field!";
    } else if (!letters.test(formData.name)) {
      formErrors.name = "Please enter only characters!";
    }

    // Email validation
    if (!formData.email) {
      formErrors.email = "Please fill out this field!";
    }

    // Company Name validation
    if (!formData.companyName) {
      formErrors.companyName = "Please fill out this field!";
    }

    // Phone Number validation
    if (!formData.phone) {
      formErrors.phone = "Please fill out this field!";
    }

    // Subject validation
    if (!formData.subject) {
      formErrors.subject = "Please fill out this field!";
    }

    // Message validation
    if (!formData.message) {
      formErrors.message = "Please fill out this field!";
    } else if (formData.message.length < 20) {
      formErrors.message = "Message must be at least 20 characters long!";
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const response = await axios.post(
          "http://localhost:5000/api/contact",
          formData
        );
        if (response.status === 201) {
          alert("Form submitted successfully!");
          setFormData({
            name: "",
            email: "",
            companyName: "",
            country: "+91",
            phone: "",
            subject: "",
            message: "",
            checkbox: false,
          });
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        alert("Failed to submit form. Please try again.");
      }
    }
  };

  const handleReset = () => {
    setFormData({
      name: "",
      email: "",
      companyName: "",
      country: "",
      phone: "",
      subject: "",
      message: "",
      checkbox: false,
    });
    setErrors({});
  };

  return (
    <div style={{ backgroundColor: "#eee" }}>
      <Header />
      <div className="contact-us-container">
        <div className="contact-us-wrapper">
          <div className="contact-us-form">
            <h4 className="contact-us-heading">GET IN TOUCH</h4>
            <h2
              className="contact-us-form-headline"
              style={{ marginBottom: "10px" }}
            >
              Send Us a Message
            </h2>
            <form
              id="submit-form"
              onSubmit={handleSubmit}
              className="contact-us-form-grid"
            >
              <p className="contact-us-form-field">
                <input
                  id="name"
                  className="contact-us-form-input"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your Name*"
                />
                {errors.name && <small className="error">{errors.name}</small>}
              </p>
              <p className="contact-us-form-field">
                <input
                  id="email"
                  className="contact-us-form-input"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your Email*"
                />
                {errors.email && (
                  <small className="error">{errors.email}</small>
                )}
              </p>
              <p className="contact-us-form-field">
                <input
                  id="companyName"
                  className="contact-us-form-input"
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  placeholder="Company Name*"
                />
                {errors.companyName && (
                  <small className="error">{errors.companyName}</small>
                )}
              </p>
              <p className="contact-us-form-field">
                <label>
                  <select
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    className="contact-us-form-input"
                  >
                    <option value="+91">+91</option>
                    <option value="+1">+1</option>
                    <option value="+44">+44</option>
                    <option value="+61">+61</option>
                  </select>
                </label>
              </p>
              <p className="contact-us-form-field">
                <input
                  type="number"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  onWheel={(e) => e.target.blur()}
                  className="contact-us-form-input"
                />
                {errors.phone && (
                  <span className="error">{errors.phone}</span>
                )}
              </p>
              <p className="contact-us-form-field full-width">
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject/Interested in"
                  value={formData.subject}
                  onChange={handleChange}
                  className="contact-us-form-input"
                />
                {errors.subject && (
                  <span className="error">{errors.subject}</span>
                )}
              </p>
              <p className="contact-us-form-field full-width">
                <textarea
                  id="message"
                  name="message"
                  minLength="20"
                  cols="30"
                  rows="7"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Your Message*"
                  className="contact-us-textarea"
                ></textarea>
                {errors.message && (
                  <small className="error">{errors.message}</small>
                )}
              </p>
              <p className="contact-us-form-field full-width">
                <input
                  type="checkbox"
                  name="checkbox"
                  checked={formData.checkbox}
                  onChange={handleChange}
                  style={{ marginRight: "10px" }}
                />
                Yes, I would like to receive communications by call/email about
                Company's services.
              </p>
              <p className="contact-us-form-buttons">
                <input type="submit" className="submit-btn" value="Submit" />
                <button
                  type="button"
                  className="reset-btn"
                  onClick={handleReset}
                >
                  Reset
                </button>
              </p>
            </form>
          </div>
          <div className="contact-us-contacts">
            <ul className="contact-us-info-list">
              <li>
                Have any questions? Let’s get started and start a conversation
                <span className="highlight-text-grey"> today!</span> We’re here
                to help and answer your queries.
              </li>
              <span className="highlight-contact-info">
                <li className="email-info" style={{ cursor: "pointer" }}>
                  <i className="fa fa-envelope" aria-hidden="true"></i> info@purohittechnosoft.com
                </li>
                <li style={{ cursor: "pointer" }}>
                  <i className="fa fa-phone" aria-hidden="true"></i>
                  <span className="highlight-text"> +91 7891266745</span>
                </li>
              </span>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
